(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        select: this.querySelector('select')
      };
      this.elements.select.addEventListener('change', this.onItemChange.bind(this));
    }

    onItemChange(event) {
      const form = this.querySelector('form');
      if (form) form.submit();
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const throttleScroll = function(func, rate) {
    var lastTime = new Date();
    return function() {
      const now = new Date();
      if ((now - lastTime >= rate) || (window.pageYOffset<= 0)) {
        func();
        lastTime = now;
      }
    };
  };

  class ScrollHeader extends HTMLElement {
    constructor() {
      super();
      this.scrollPosition = window.pageYOffset;
      document.addEventListener('scroll', throttleScroll(this.onScroll.bind(this), 500));
    }

    onScroll() {
      if (document.body.classList.contains('menu-has-open') || document.body.classList.contains('search-open'))
        return;

      const currentScroll = window.pageYOffset;
      if (currentScroll> 60 && currentScroll > (this.scrollPosition + 32)) {
        this.classList.add('header--hide');
        this.scrollPosition = currentScroll;
      } else if (currentScroll <= 0 || currentScroll < (this.scrollPosition - 32)) {
        this.classList.remove('header--hide');
        this.scrollPosition = currentScroll;
      }
    }

    showHeader() {
      this.classList.remove('header--hide');
      this.scrollPosition = window.pageYOffset;
    }
  }

  class HeaderSearch extends HTMLElement {
    constructor() {
      super();

      this.STATUS__RESET = 'search--reset';
      this.STATUS__LOADING = 'search--loading';
      this.STATUS__RESULTS = 'search--results';
      this.STATUS__NO_RESULTS = 'search--no-results';
      this.STATUS__ERROR = 'search--error';

      this.search = this.querySelector('.search');
      this.toggleButton = this.querySelector('.search__toggle');
      this.closeButton = this.querySelector('.search__close');
      this.input = this.querySelector('.search__input');
      this.resetButton = this.querySelector('.search__reset');
      this.results = this.querySelector('#search-results');
      this.overlay = this.querySelector('.search-overlay');
      this.searchTerm = '';

      this.input.addEventListener('input', this.debounce((event) => {
        this.onInput(event);
      }, 300).bind(this));

      this.input.addEventListener('focus', this.open.bind(this));
      this.toggleButton.addEventListener('click', this.toggle.bind(this));
      this.closeButton.addEventListener('click', this.close.bind(this));
      this.resetButton.addEventListener('click', this.onFormReset.bind(this));
      this.overlay.addEventListener('click', this.close.bind(this));
    }

    open() {
      this.search.classList.add('is-open');
      document.body.classList.add('search-open');
      this.input.focus({ preventScroll: true });
      this.input.setAttribute('aria-expanded', true);
    }

    close() {
      this.search.classList.remove('is-open');
      document.body.classList.remove('search-open');
      this.input.blur();
      this.input.setAttribute('aria-expanded', false);
    }

    toggle() {
      this.search.classList.contains('is-open') ? this.close() : this.open();
    }

    toggleResetButton() {
      if (this.searchTerm.length > 0) {
        this.resetButton.classList.add('active');
      } else {
        this.resetButton.classList.remove('active');
      }
    }

    getQuery() {
      return this.input.value.trim();
    }

    onInput() {
      const newSearchTerm = this.getQuery();
      this.searchTerm = newSearchTerm;

      if (this.searchTerm.length > 0) {
        this.resetButton.classList.add('active');
      } else {
        this.resetButton.classList.remove('active');
        this.setStatus(this.STATUS__RESET);
        return;
      }

      this.getResults(this.searchTerm);


    }

    onSuggestionClick(event) {
      event.preventDefault();
      this.input.value = event.currentTarget.dataset.query;
      this.input.dispatchEvent(new InputEvent('input'));
    }

    onFormReset(event) {
      event.preventDefault();
      this.searchTerm = '';
      this.input.value = '';
      this.input.dispatchEvent(new InputEvent('input'));
      this.input.focus();
      this.setStatus(this.STATUS__RESET);
    }

    onFormSubmit(event) {
      if (!this.getQuery().length) event.preventDefault();
    }

    getResults(searchTerm) {
      this.setStatus(this.STATUS__LOADING);
      fetch(`/search/suggest?q=${searchTerm}&section_id=search-results`)
        .then((response) => {
          if (!response.ok) {
            this.setStatus(this.STATUS__ERROR);
            var error = new Error(response.status);
            throw error;
          }
          return response.text();
        })
        .then((text) => {
          this.setStatus(this.STATUS__RESULTS);
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-search-results').innerHTML;
          this.results.innerHTML = resultsMarkup;
          const suggestions = Array.from(this.results.querySelectorAll('.search-results__query-item'));
          suggestions.forEach(suggestion => {
            suggestion.addEventListener('click', this.onSuggestionClick.bind(this));
          });
        })
        .catch((error) => {
          this.setStatus(this.STATUS__ERROR);
          throw error;
        });
    }

    setStatus(status) {
      if (status !== this.STATUS__RESULTS) {
        this.results.replaceChildren();
      }

      this.search.classList.remove(
        this.STATUS__RESET,
        this.STATUS__LOADING,
        this.STATUS__RESULTS,
        this.STATUS__NO_RESULTS,
        this.STATUS__ERROR
      );
      this.search.classList.add(status);
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }

  class HeaderMenu extends HTMLElement {
    constructor() {
      self = super();
      const toggleButtons = Array.from(self.querySelectorAll('.menu-toggle, .menu-dropdown-toggle'));
      const closeButton = self.querySelector('.menu-close');
      const overlay = self.querySelector('.menu-overlay');
      const hoverItems = Array.from(self.querySelectorAll('.menu-item.has-menu-dropdown'));
      const mediaQuery = window.matchMedia('(min-width: 960px)');
      let showToggle = true;
      let timer;

      function handleToggleClick(evt) {
        toggle(evt.currentTarget.nextElementSibling);
      }

      function handleCloseClick(evt) {
        close(evt.currentTarget.parentNode.parentNode);
      }

      function handleOverlayClick(evt) {
        close(evt.currentTarget.previousElementSibling);
      }

      function handleMouseEnter(evt) {
        clearTimeout(timer);
        open(evt.currentTarget.querySelector('.menu-dropdown'));
      }

      function handleMouseLeave() {
        timer = setTimeout(() => {
          close(this.querySelector('.menu-dropdown'));
        }, 200);
      }

      function open(element) {
        const currentlyOpens = Array.from(self.querySelectorAll('.menu-dropdown'));
        currentlyOpens.forEach(currentlyOpen => {
          close(currentlyOpen);
        });
        element.classList.add('is-open');
        element.parentNode.classList.add('has-open');
        document.body.classList.add('menu-has-open');
      }

      function close(element) {
        element.classList.remove('is-open');
        element.parentNode.classList.remove('has-open');
        if (element.classList.contains('menu') || !showToggle)
          document.body.classList.remove('menu-has-open');
      }

      function toggle(element) {
        element.classList.contains('is-open') ? close(element) : open(element);
      }

      function clean() {
        const activeElements = Array.from(self.querySelectorAll('.is-open, .has-open'));
        activeElements.forEach(activeElement => {
          activeElement.classList.remove('is-open', 'has-open');
        });
        self.classList.remove('has-open');
        document.body.classList.remove('menu-has-open');
      }

      function addMouseEvents() {
        hoverItems.forEach(hoverItem => {
          hoverItem.addEventListener('mouseenter', handleMouseEnter);
          hoverItem.addEventListener('mouseleave', handleMouseLeave);
        });
      }

      function removeMouseEvents() {
        hoverItems.forEach(hoverItem => {
          hoverItem.removeEventListener('mouseenter', handleMouseEnter);
          hoverItem.removeEventListener('mouseleave', handleMouseLeave);
        });
      }

      function handleMediaQueryChange(evt) {
        if (evt.matches) {
          showToggle = false;
          clean();
          addMouseEvents();
        } else {
          showToggle = true;
          clean();
          removeMouseEvents();
        }
      }

      toggleButtons.forEach(toggleButton => {
        toggleButton.addEventListener('click', handleToggleClick);
      });

      closeButton.addEventListener('click', handleCloseClick);

      overlay.addEventListener('click', handleOverlayClick);

      handleMediaQueryChange(mediaQuery);
      mediaQuery.addEventListener('change', handleMediaQueryChange);
    }
  }

  customElements.define('scroll-header', ScrollHeader);
  customElements.define('header-search', HeaderSearch);
  customElements.define('header-menu', HeaderMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductVariants extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.variants = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    this.form = document.querySelector('product-form');
    this.addButton = this.form.querySelector('button[name="add"]');
    this.inputId = this.form.querySelector('input[name="id"]');
    this.price = document.querySelector('product-price');
    this.availability = document.querySelector('product-availability');
  }

  onVariantChange() {
    this.disableAddButton();
    this.getOptions();
    this.getVariantId();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.setVariantNonexistent();
    } else {
      this.setVariantSelected();
    }
  }

  getOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  getVariantId() {
    this.currentVariant = this.variants.find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  setVariantNonexistent() {
    this.setPrice(null, null, null, false, true);
    this.setAvailability(false, true);
    this.inputId.value = null;
    this.inputId.dispatchEvent(new Event('change', { bubbles: true }));
  }

  setVariantSelected() {
    this.setPrice(
      this.currentVariant.price,
      this.currentVariant.compare_at_price,
      this.currentVariant.percent,
      this.currentVariant.available,
      false
    );
    this.setAvailability(this.currentVariant.available, false);
    this.inputId.value = this.currentVariant.id;
    this.inputId.dispatchEvent(new Event('change', { bubbles: true }));
    if (this.currentVariant.available) {
      this.activateAddButton();
    }

  }

  setPrice(price, compareAtPrice, percent, available, nonexistent) {
    this.price.dataset.price = price;
    this.price.dataset.compareAtPrice = compareAtPrice;
    this.price.dataset.percent = percent;
    this.price.dataset.available = available;
    this.price.dataset.nonexistent = nonexistent;
    this.price.dispatchEvent(new Event('change', { bubbles: false }));
  }

  setAvailability(available, nonexistent) {
    this.availability.dataset.available = available;
    this.availability.dataset.nonexistent = nonexistent;
    this.availability.dispatchEvent(new Event('change', { bubbles: false }));
  }

  disableAddButton() {
    this.addButton.setAttribute('disabled', 'disabled');
  }

  activateAddButton() {
    this.addButton.removeAttribute('disabled');
  }

  removeErrorMessage() {
    this.form.handleErrorMessage();
  }
}

class ProductPrice extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onChange);
  }

  onChange() {
    this.querySelector('.price--dynamic .price__regular--normal .money').textContent = this.dataset.price === 'null' ? 'N/A' : this.dataset.price;
    this.querySelector('.price--dynamic .price__compare .money').textContent = this.dataset.compareAtPrice;
    this.querySelector('.price--dynamic .price__regular--sale .money').textContent = this.dataset.price + ' ' + this.dataset.percent;

    if (this.dataset.compareAtPrice !== 'null' && this.dataset.percent !== 'null') {
      this.querySelector('.price--dynamic .price__regular--normal').setAttribute('hidden', '');
      this.querySelector('.price--dynamic .price__compare').removeAttribute('hidden');
      this.querySelector('.price--dynamic .price__regular--sale').removeAttribute('hidden');
      this.querySelector('.price--dynamic .price__badge--sale').removeAttribute('hidden');
    } else {
      this.querySelector('.price--dynamic .price__regular--normal').removeAttribute('hidden');
      this.querySelector('.price--dynamic .price__compare').setAttribute('hidden', '');
      this.querySelector('.price--dynamic .price__regular--sale').setAttribute('hidden', '');
      this.querySelector('.price--dynamic .price__badge--sale').setAttribute('hidden', '');
    }
  }
}

class ProductAvailability extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onChange);
  }

  onChange() {
    if (this.dataset.nonexistent === 'true') {
      this.querySelector('.product-availability__available').setAttribute('hidden', '');
      this.querySelector('.product-availability__unavailable').setAttribute('hidden', '');
      this.querySelector('.product-availability__nonexistent').removeAttribute('hidden');
    } else if (this.dataset.available === 'true') {
      this.querySelector('.product-availability__available').removeAttribute('hidden');
      this.querySelector('.product-availability__unavailable').setAttribute('hidden', '');
      this.querySelector('.product-availability__nonexistent').setAttribute('hidden', '');
    } else {
      this.querySelector('.product-availability__available').setAttribute('hidden', '');
      this.querySelector('.product-availability__unavailable').removeAttribute('hidden');
      this.querySelector('.product-availability__nonexistent').setAttribute('hidden', '');
    }
  }
}

class AccordionRow extends HTMLElement {
  constructor() {
    super();
    this.header = this.querySelector('.accordion__heading');
    this.panel = this.querySelector('.accordion__panel');
    
    this.header.addEventListener('click', this.toggle.bind(this));
  }

  open() {
    this.classList.add('is-open');
    this.header.setAttribute('aria-expanded', 'true');
    this.panel.setAttribute('aria-hidden', 'false');
  }

  close() {
    this.classList.remove('is-open');
    this.header.setAttribute('aria-expanded', 'false');
    this.panel.setAttribute('aria-hidden', 'true');
  }

  toggle() {
    this.classList.contains('is-open') ? this.close() : this.open();
  }
}

customElements.define('product-variants', ProductVariants);
customElements.define('product-price', ProductPrice);
customElements.define('product-availability', ProductAvailability);
customElements.define('accordion-row', AccordionRow);


  } catch(e) { console.error(e); }
})();

})();
